//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"SelectedConfigurationName",1,0],[0,"SelectedConfigurationPart",1,"Part",0]],[[["bUpdateTags"],"RefreshSinumerik",{},1,0],[["srcFile","destFile"],"GetFile",{},2,0],[["numInstances","ownerParts"],"GetInstanceNames",{R_:{names:""}},0,0],[["ownerParts","names"],"SetInstanceNames",{},2,0],[["instanceName","ownerPart","numTags","tagInfos","cyclic","stepFactor"],"GetInstanceInformation",{},2,0],[["instanceName","ownerPart","tagInfos","cyclic","stepFactor"],"SetInstanceInformation",{},5,0],[["instanceName","ownerPart"],"GetMagazineTool",{R_:{magazineTool:"Mechatronics.DynamicObjectTable"}},2,0],[["instanceName","ownerPart","magazineTool"],"SetMagazineTool",{},3,0]],[]];
SPLM.Mechatronics.SinumerikClientBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SinumerikClientBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SinumerikClientBuilder.TagInfo = class{
    constructor(name,eAreaType,eIOType,dataType,value,bChecked){
        this.name=name;this.eAreaType=eAreaType;this.eIOType=eIOType;this.dataType=dataType;this.value=value;this.bChecked=bChecked;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Eareatype(){return this.eAreaType}
    set Eareatype(val){this.eAreaType = val}
    get Eiotype(){return this.eIOType}
    set Eiotype(val){this.eIOType = val}
    get Datatype(){return this.dataType}
    set Datatype(val){this.dataType = val}
    get Value(){return this.value}
    set Value(val){this.value = val}
    get Bchecked(){return this.bChecked}
    set Bchecked(val){this.bChecked = val}
};

SPLM.Mechatronics.SinumerikClientBuilder.AreaType = Object.freeze({
    "Unknow" : "Unknow", "Plc" : "Plc", "Nck" : "Nck"});

export default SPLM;